module.exports = __webpack_public_path__ + "static/img/welcome-sp.7dec23d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/welcome-sp.png
// module id = 7tNf
// module chunks = 41